import {useMemo, useState} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function AgentsPrivateWeapons({ data }) {
    const privateWeapons = data?.privateWeapons ?? [];
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        { headerName: "Número da arma", field: "weaponNumber", flex: 1 },
        { headerName: "Espécie", field: "species", flex: 1},
        { headerName: "Calibre", field: "caliber", flex: 1 },
        { headerName: "SINARM", field: "sinarm", flex: 1 }
    ]), [privateWeapons])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] mb-2">
                Armas particulares
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={privateWeapons ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}
